/**
 * Simplified Chinese (CNY) tag-focused transaction feed for the tags use case.
 */

/** @type {Array<import('../../mock-tagged-transactions.js').MockTaggedTransaction>} */
export const MOCK_TAGGED_TRANSACTIONS_ZH_CN = [
	{
		id: 'tag-1',
		date: '2026-08-02',
		type: 'Purchase',
		amount: 480,
		description: '商务午餐',
		accountId: 'acc-credit',
		accountName: '返利卡',
		currency: 'CNY',
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 2,
		tagNames: '业务, 税务',
	},
	{
		id: 'tag-2',
		date: '2026-08-01',
		type: 'Deposit',
		amount: 24000,
		description: '工资',
		accountId: 'acc-checking',
		accountName: '常青银行',
		currency: 'CNY',
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 2,
		tagNames: '收入',
	},
	{
		id: 'tag-3',
		date: '2026-07-29',
		type: 'Withdrawal',
		amount: 11000,
		description: '房租',
		accountId: 'acc-checking',
		accountName: '常青银行',
		currency: 'CNY',
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 2,
		tagNames: '账单',
	},
	{
		id: 'tag-4',
		date: '2026-07-25',
		type: 'Purchase',
		amount: 1250,
		description: '业务书籍',
		accountId: 'acc-credit',
		accountName: '返利卡',
		currency: 'CNY',
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 2,
		tagNames: '业务, 税务',
	},
	{
		id: 'tag-5',
		date: '2026-07-20',
		type: 'Purchase',
		amount: 2200,
		description: '软件订阅',
		accountId: 'acc-credit',
		accountName: '返利卡',
		currency: 'CNY',
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 2,
		tagNames: '业务, 税务',
	},
	{
		id: 'tag-6',
		date: '2026-07-18',
		type: 'Purchase',
		amount: 320,
		description: '超市',
		accountId: 'acc-credit',
		accountName: '返利卡',
		currency: 'CNY',
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 2,
		tagNames: '餐饮',
	},
];
